import { useState, useEffect } from "react";
import moment from "moment";
import {
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import { AttendanceService } from "../modules/service";
import { IAttendance } from "../modules/interface";

export const AttendanceReportComponent = (props: { secret: string }) => {
  const [attendance, setAttendance] = useState<IAttendance[]>([]);

  useEffect(() => {
    AttendanceService(props.secret)
      .then((response) => {
        setAttendance(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [props.secret]);

  return (
    <>
      <Button>Last 10 attendance records via APP</Button>
      {attendance.length > 0 ? (
        <div>
          {attendance.map((attendance) => (
            <Accordion key={attendance.uuid}>
              <AccordionSummary
                expandIcon={<ExpandMore />}
                aria-controls={`panel${attendance.uuid}-content`}
                id={`panel${attendance.uuid}-header`}
              >
                <Typography
                  sx={{ width: "20%", flexShrink: 0 }}
                  variant="subtitle2"
                >
                  {attendance.lecturer.code}
                </Typography>
                <Typography
                  sx={{ color: "text.secondary" }}
                  variant="subtitle2"
                >
                  <FormatDateComponent date={attendance.timestamp} />
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  Attendance granted for {attendance.lecturer.user.first_name}{" "}
                  {attendance.lecturer.user.last_name} (
                  {attendance.lecturer.code}) class on{" "}
                  <FormatDateComponent date={attendance.timestamp} />
                  <br />
                  <br />
                  <Typography
                    variant="caption"
                    sx={{ color: "text.secondary" }}
                  >
                    Attendance ID
                    <br />
                    <strong>{attendance.uuid}</strong>
                    <br />
                    Attendance timestamp: <br />
                    <strong>{attendance.timestamp}</strong>
                    <br />
                  </Typography>
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </div>
      ) : (
        <>
          <Typography>No attendance found</Typography>
        </>
      )}
    </>
  );
};

const FormatDateComponent = (props: { date: string }) => {
  const date = moment(props.date).format("DD/MM/YYYY");
  const time = moment(props.date).format("hh:mm a");

  return (
    <>
      {date} at {time}
    </>
  );
};
